// Reset (revoke) MFA enrolment for an admin. The next time they sign in
// they'll be forced to enrol again. List refresh updates the MFA chip;
// audit refresh shows the reset event in the timeline.

import { useMutation, useQueryClient } from '@tanstack/vue-query'

import { resetMfa } from '../adminsEndpoints'
import { adminsQueryKeys } from '../adminsQueryKeys'

export function useResetMfaMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => resetMfa(id),
    onSuccess: (_, id) => {
      qc.invalidateQueries({ queryKey: adminsQueryKeys.lists() })
      qc.invalidateQueries({ queryKey: adminsQueryKeys.audit(id) })
    },
  })
}
